
<template>
  <div class="main">
    <div class="nav-wrap">
      <nav-bar :routers="routers"></nav-bar>
    </div>

    <router-view :grade-id="gradeId" :subject-list="subjectList" :is-more="isMore" :is-split="isSplit" :school-id="schoolId"></router-view>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
export default {
  props: ["gradeId", "subjectList", "isMore", "isSplit", "schoolId"],

  data () {
    return {
      routers: [
        {
          path:
            "/exam/gaokao/report/" + this.$route.params.id + "/summary/basic",
          name: "基础成绩分析"
        },
        {
          path:
            "/exam/gaokao/report/" +
            this.$route.params.id +
            "/summary/scoreSection",
          name: "分数段占比"
        },
        {
          path:
            "/exam/gaokao/report/" +
            this.$route.params.id +
            "/summary/transcript",
          name: "成绩单"
        }
      ]
    };
  },

  components: {
    NavBar
  }
};
</script>

<style scoped lang="scss">
.main {
  display: flex;
  flex-flow: row;
  .nav-wrap {
    position: relative;
    margin: 14px 20px 0 0;
    width: 155px;
  }
}
</style>
